"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isString(value) {
    return typeof value === 'string';
}
exports.default = isString;
//# sourceMappingURL=is-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/utils/is-string.js
// module id = ./node_modules/subscriptions-transport-ws/dist/utils/is-string.js
// module chunks = 53 54